import TableTemplate from "../TableTemplate/tableTemplate";
import {
  IPortfolioInsTableReport,
  IPortfolioInsTableSearchParams,
  IPortfolioInsTableExtraData,
} from "../../Interfaces/portfolio";
import { CommonTableUI } from "../TableTemplate/common";
import { getPortfolioInsTable } from "../../Requests/portfolioRequests";
// Local Component
import { Additional } from "./Additional";

interface IProps {
  searchParams: IPortfolioInsTableSearchParams;
  onExtraDataChange?: (extraData: IPortfolioInsTableExtraData[] | null) => void;
}

const PortfoInsTable = ({ searchParams, onExtraDataChange }: IProps) => {
  return (
    <TableTemplate<IPortfolioInsTableSearchParams, IPortfolioInsTableReport>
      getDataTable={getPortfolioInsTable}
      onResponse={(response) => {
        onExtraDataChange?.(
          (response as { extraData?: IPortfolioInsTableExtraData[] | null })
            .extraData ?? null,
        );
      }}
      TableUI={({ reports, onAction, sortingType, setSortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          sortingType={sortingType}
          setSortingType={setSortingType}
          tableBoxClassName="!mx-0 max-h-[calc(100dvh-230px)] overflow-y-auto"
          AdditionalBody={Additional}
        />
      )}
      withSort
      searchParameters={searchParams}
    />
  );
};

export default PortfoInsTable;
